/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
//environments desa
const v = 'https://desapoyo.nutricionistaspba.org.ar/api';


// http://142.44.242.196:9002/
//environments production
//const v = "//51.79.74.190:9000/api";
// const vlogin = "//51.79.74.190:8900/api";

/**domains:
 path: /api/domains/**

 /api/domains/domain

 evaluation:
 path: /api/evaluations/**

 /api/evaluations/energy-estimate
 /api/evaluations/medical-evaluations
 /api/evaluations/timelines

 history:
 path: /api/history/**

 /history_formulary_completed
 /history_formulary
 /{historyFormId}/question

 persons:
 path: /api/persons/**

 /person

 report-data:
 path: /api/report-data/**


 consultations:
 path: /api/consultations/**

 /medical-consultation

 images:
 path: /api/images/**


 plan:
 path: /api/plan/**



 */


export const environment = {
  production: false,
  brand: 'colegio',
  api: {
    domain: `${v}/domains/domain`,
    history_formulary: `${v}/history/history_formulary`,
    history_question: `${v}/history`,
    person: `${v}/persons/person`,
    persons: `${v}/persons/person`,
    history_formulary_completed: `${v}/history/history_formulary_completed`,
    evaluation: `${v}/evaluations`,
    report_data: `${v}/report-data/report`,
    security: `${v}/security`,
    medical_consultation: `${v}/consultations/medical-consultation`,
    medical_consultation_data: `${v}/consultations/medical-consultation/basicMedicalConsultationData`,
    exams: `${v}/images/medical-consultation-upload`,
    documents: `${v}/images/documents`,
    new_evaluation: v + '/evaluations/medical-evaluations',
    plans: `${v}/images/plan`,
    plan_prearmed: `${v}/images/plan/prearmedPlan`,
    config_reference: `${v}/images/referencial-data`,
    images: `${v}/images/foodImages`,
    fileShareMobile: `${v}/images/fileShareMobile`,
    user: `${v}/users/user`,
    registerUser: `${v}/users/user`,
    energy: `${v}/evaluations/energy-estimate`,
    config_logos: `${v}/images/configLogos`,
    plan_period: `${v}/images/plan/periodPlan`,
    person_avatar: `${v}/images/personAvatar`,
    patient_objective: `${v}/evaluations/objetive`,
    previus_medical_consultation: `${v}/consultations/previus-medical-consultation`,
    imagesBioDexa: `${v}/images`,
    ia: `${v}/ia`,
    payments: `${v}/payments`,
    jobs: `${v}/jobs`,
    attendance_schedules: `${v}/appointments/attendance-schedules`,
    type_consultations: `${v}/appointments/type-consultations`,
    virtual_appointment: `${v}/appointments/virtual-appointment`,
    appointments: `${v}/appointments/appointments`,

  },
  apiBase: v,
  basicAuth: 'YW50cm9zcG9ydDphbnRyb3Nwb3J0LXNlY3VyaXR5LXNlY3JldA==',
  paypalClientId: 'AW874IhLrL7Udgm6pRoA6NPhyIUP_K67igMdBEnGlOpdTlvt_Gnzx4lbJbxNb8rYfiGfUtGU99qAr2Le',
  mercadoPagoToken: 'APP_USR-a97f43ef-47a9-42fa-94ef-ea13aa58aadd',

};
